export default __webpack_public_path__ + "static/media/cp_db_dropbox.7f1fdf91.svg";